import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import s from "./styles";

function Loading({ height = "60vh", size = "large", showTip = true }) {
  const { t } = useTranslation();
  return (
    <s.loadingContainer height={height}>
      <Spin
        style={{ color: "#000" }}
        size={size}
        tip={showTip && t("general.loading")}
      />
    </s.loadingContainer>
  );
}

export default Loading;
